import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="mt-20 pt-8 bg-luxury border-t border-gold/20">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-muted-foreground">
            &copy; 2025 BlueLux Team Portal. All rights reserved.
          </p>
          <div className="flex space-x-4 text-sm text-muted-foreground mt-4 md:mt-0">
            <Link to="/" className="hover:text-primary transition-colors">
              Home
            </Link>
            <Link to="/wiki/welcome" className="hover:text-primary transition-colors">
              Team Portal
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
